import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { Provider } from 'react-redux'

import PublicRoutes from './PublicRoutes'
import ExternalRoutes from './ExternalRoutes'

import store from '../store/index'
import PolicyPrivacy from '../modules/Pages/PolicyPrivacy'
import FamiliesPage from '../modules/Pages/Families'
import CerimonyPage from '../modules/Pages/Cerimonies'
import PartnersPage from '../modules/Pages/Partners'
import HelmetDynamic from '../modules/Pages/helmet'

export default function MainRoutes() {
  return (
    <Provider store={store}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<PublicRoutes />} />
          <Route
            path="/parceiros"
            element={
              <>
                <HelmetDynamic
                  title="Parceiros"
                  description="Estreitamos caminhos para a entregua de mensagens de condolências"
                  path="/parceiros"
                />
                <PartnersPage />
              </>
            }
          />
          <Route
            path="/familias"
            element={
              <>
                <HelmetDynamic
                  title="Famílias"
                  description="A KFamily promove o apoio ajudando famílias e empresas a enviar facilmente mensagens de simpatia, fortalecendo os laços em momentos difíceis."
                  path="/familias"
                />
                <FamiliesPage />
              </>
            }
          />
          <Route
            path="/cerimonias"
            element={
              <>
                <HelmetDynamic
                  title="Cerimônias"
                  description="Enviar condolências é simples com a KFamily: envie sua mensagem, receba a confirmação e nós garantimos que ela chegue ao destinatário certo de forma rápida e segura."
                  path="/cerimonias"
                />
                <CerimonyPage />
              </>
            }
          />
          <Route
            path="/politica-de-privacidade"
            element={
              <>
                <HelmetDynamic
                  title="Política de Privacidade"
                  description="Esta Política de Privacidade descreve as nossas políticas e procedimentos sobre a recolha e utilização das suas informações."
                  path="/politica-de-privacidade"
                />
                <PolicyPrivacy />
              </>
            }
          />
          <Route path="/email" element={<ExternalRoutes />} />
        </Routes>
      </BrowserRouter>
    </Provider>
  )
}
